import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerWorker } from './push';
import { watchForInstallPrompt } from './install/prompt';
import './styles.css';

/*
 * Before React, and before any session is known.
 *
 * Chrome offers to install a site only once a service worker with a `fetch` handler is
 * registered, so registering it from inside the notifications panel meant the install prompt
 * arrived after signing in — useless to a learner whose only way of being reached is push,
 * who needs the app on their home screen before they have an account. See `registerWorker`;
 * it cannot throw and is not awaited, so nothing below waits on it and no browser that
 * refuses service workers loses the site.
 */
registerWorker();

/*
 * Also before React, and for a sharper version of the same reason (F-121).
 *
 * Chromium fires `beforeinstallprompt` once, as soon as it decides the site qualifies, and an
 * unhandled event is *gone* — taking with it the only genuine one-tap install this app has.
 * On a warm load that moment is before any component has mounted, so a listener attached
 * inside the screen that shows the button would never see it.
 */
watchForInstallPrompt();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
